import app from '@/main';

export const hideFromNavChildClient = () => {
  const vm = app();
  return vm?.$rsGlobals.$isClientChild;
};

export const hideNavFromPropertyChildClient = () => {
  const vm = app();
  return vm?.$rsGlobals.$isPropertyChild(vm.$store.getters.sidebarHeaderData.data);
};
